/*
 * @Description: 权限点
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2022-02-14 21:15:44
 * @LastEditors: zhao - 🍉
 */

import {handleExportParams} from "../utils";

export  const authKey = [
    {  name: '门店管理',
        isJr: true,
        /*code: 'l',
        ahthKey: ['merchant'],*/
        children: [
            {
                // code:'a1' ,
                name:'门店管理' ,  isJr: true,ahthKey:['merchant'],children:[
                    { code:'l-1' , name:'菜单',ahthKey:['merchant'] },
                    { code:'l-1-2' , name:'新增',ahthKey:['merchant'] },
                    { code:'l-1-3' , name:'编辑',ahthKey:['merchant'] },
                    { code:'l-1-4' , name:'删除',ahthKey:['merchant'] },
                 /*   { code:'l-1-5' , name:'建融日志',ahthKey:['employee'] },*/
                ]
            }
        ]  },
    // {
    //     name: '提醒',
    //     // code: 'a',
    //     children:[
    //         {
    //             // code:'a1' ,
    //             name:'收款提醒' ,ahthKey:['merchant','employee'],children:[
    //                 { code:'a-1' , name:'菜单',ahthKey:['merchant','employee'] },
    //                 { code:'a-1-2' , name:'导出',ahthKey:['merchant','employee'] },
    //                 { code:'a-1-3' , name:'发送催收短信',ahthKey:['merchant','employee'] },
    //             ]
    //         }
    //     ]
    // },
    {
        name: '用户管理',
        // code: 'b',
        children:[
            {
                // code:'b1' ,
                name:'租客' ,ahthKey:['employee'],children:[
                    { code:'b-1' , name:'菜单',ahthKey:['employee'] },
                    { code:'b-1-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'b-1-3' , name:'新增企业用户' ,ahthKey:['employee']},
                    { code:'b-1-4' , name:'新增个人用户',ahthKey:['employee'] },
                ]
            },
            {
                name:'管家' ,ahthKey:['employee'],children:[
                    { code:'b-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'b-2-1' , name:'详情',ahthKey:['employee'] },
                    { code:'b-2-2' , name:'发送签约短信' ,ahthKey:['employee']},
                ]
            },
            {
                name:'微信客服' ,ahthKey:['employee'],children:[
                    { code:'n-1' , name:'菜单',ahthKey:['employee'] },
                    { code:'n-1-1' , name:'顾客列表',ahthKey:['employee'] },
                ]
            },
            {
                name:'微信客户列表' ,ahthKey:['employee'],children:[
                    { code:'n-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'n-2-1' , name:'更换顾问',ahthKey:['employee'] },
                    { code:'n-2-2' , name:'更换昵称',ahthKey:['employee'] },
                    { code:'n-2-3' , name:'更换标签',ahthKey:['employee'] },
                    { code:'n-2-4' , name:'聊天记录',ahthKey:['employee'] },
                ]
            }
        ]
    },
    {
        name: '房源管理',
        // code: 'c',
        children:[
            {
                // code:'c2' ,
                name:'小区/楼栋维护' ,ahthKey:['merchant','employee'],children:[
                    { code:'c-2' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'c-2-2' , name:'编辑',ahthKey:['merchant'] },
                    { code:'c-2-3' , name:'新增',ahthKey:['merchant'] },
                    { code:'c-2-4' , name:'删除',ahthKey:['merchant'] },
                    // { code:'c-2-5' , name:'建融日志',ahthKey:['employee'] },
                ]
            },
            {
                // code:'c1' ,
                name:'户型维护' ,isJr:true,ahthKey:['merchant','employee'],children:[
                    { code:'c-4' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'c-4-2' , name:'编辑',ahthKey:['merchant'] },
                    { code:'c-4-3' , name:'新增',ahthKey:['merchant'] },
                    { code:'c-4-4' , name:'删除',ahthKey:['merchant'] },
                    // { code:'c-4-5' , name:'建融日志',ahthKey:['employee'] },
                ]
            },
            {
                // code:'c1' ,
                name:'房源维护' ,ahthKey:['merchant','employee'],children:[
                    { code:'c-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'c-1-2' , name:'编辑',ahthKey:['merchant'] },
                    { code:'c-1-3' , name:'新增',ahthKey:['merchant'] },
                    { code:'c-1-4' , name:'删除',ahthKey:['merchant'] },
                    { code:'c-1-5' , name:'导出' ,ahthKey:['merchant','employee']},
                    { code:'c-1-6' , name:'导入模版下载' ,ahthKey:['merchant']},
                    { code:'c-1-7' , name:'批量导入',ahthKey:['merchant'] },
                    // { code:'c-1-8' , name:'建融日志',ahthKey:['employee'] },
                ]
            },



        ]
    },
    {
        name: '租赁管理',
        // code: 'd',
        children:[
            {
                name:'房源租赁' ,ahthKey:['merchant','employee'],children:[
                    { code:'c-3' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'c-3-2' , name:'导出',ahthKey:['merchant','employee'] },
                    { code:'c-3-3' , name:'签约',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'d1' ,
                name:'租客合同' ,ahthKey:['merchant','employee'],children:[
                    { code:'d-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'d-1-2' , name:'详情',ahthKey:['merchant','employee'] },
                    { code:'d-1-3' , name:'添加账单',ahthKey:['merchant'] },
                    { code:'d-1-4' , name:'删除',ahthKey:['merchant'] },
                    { code:'d-1-5' , name:'导出合同',ahthKey:['merchant','employee'] },
                    { code:'d-1-6' , name:'合同模板下载',ahthKey:['merchant'] },
                    { code:'d-1-7' , name:'批量合同导入',ahthKey:['merchant'] },
                    { code:'d-1-8' , name:'发送合同',ahthKey:['merchant'] },
                    { code:'d-1-9' , name:'退租',ahthKey:['merchant'] },
                    { code:'d-1-10' , name:'今日已发送',ahthKey:['merchant'] },
                    { code:'d-1-11' , name:'账单模板下载',ahthKey:['merchant'] },
                    { code:'d-1-12' , name:'批量账单导入',ahthKey:['merchant'] },
                    { code:'d-1-13' , name:'上传电子合同',ahthKey:['employee'] },
                    { code:'d-1-14' , name:'上传合同附页',ahthKey:['employee'] },
                    // { code:'d-1-15' , name:'建融日志',ahthKey:['employee'] },
                    { code:'d-1-16' , name:'续签',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'d1' ,
                name:'租客合同提醒' ,ahthKey:['merchant','employee'],children:[
                    { code: 'd-10', name: '菜单', ahthKey: ['merchant','employee'] },
                    { code:'d-10-9' , name:'退租',ahthKey:['merchant'] },
                    { code:'d-10-16' , name:'续签',ahthKey:['merchant'] },
                    { code:'d-10-4' , name:'删除',ahthKey:['merchant'] },
                ]
            },
            {
              name: '合同模板', ahthKey: ['employee'], children: [
                { code: 'd-3', name: '菜单', ahthKey: ['employee'] },
                { code: 'd-3-1', name: '新增', ahthKey: ['employee'] },
                { code: 'd-3-2', name: '修改', ahthKey: ['employee'] },
              ]
            },
            {
                name: '合同审批', ahthKey: ['employee'], children: [
                    {code: 'd-4', name: '菜单', ahthKey: ['employee']},
                    {code: 'd-4-1', name: '详情', ahthKey: ['employee']},
                    {code: 'd-4-2', name: '审批', ahthKey: ['employee']},
                ]
            }

        ]
    },
    {
        name: '财务管理',
        // code: 'e',
        children:[
            {
                // code:'e1' ,
                name:'收款账单' ,ahthKey:['merchant','employee'],children:[
                    { code:'e-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'e-1-2' , name:'详情',ahthKey:['merchant','employee'] },
                    { code:'e-1-3' , name:'编辑',ahthKey:['merchant'] },
                    { code:'e-1-4' , name:'删除' ,ahthKey:['merchant']},
                    { code:'e-1-5' , name:'导出' ,ahthKey:['merchant','employee']},
                    // { code:'e-1-6' , name:'建融日志' ,ahthKey:['employee']},
                ]
            },
            {
                // code:'e2' ,
                name:'退款账单' ,ahthKey:['merchant','employee'],children:[
                    { code:'e-2' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'e-2-2' , name:'详情',ahthKey:['merchant','employee'] },
                    { code:'e-2-3' , name:'导出',ahthKey:['merchant','employee'] },
                    { code:'e-2-4' , name:'付款',ahthKey:['merchant'] },
                    { code:'e-2-5' , name:'转入收款账单',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'f1' ,
                name:'收款明细' ,ahthKey:['merchant','employee'],children:[
                    { code:'f-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'f-1-2' , name:'详情',ahthKey:['merchant','employee'] },
                    { code:'f-1-3' , name:'导出',ahthKey:['merchant','employee'] },
                ]
            },
            {
                // code:'f2' ,
                name:'项目转账' ,ahthKey:['merchant','employee'],children:[
                    { code:'f-2' , name:'菜单',ahthKey:['merchant','employee'], },
                    { code:'f-2-2' , name:'详情',ahthKey:['merchant','employee'], },
                    { code:'f-2-3' , name:'导出' ,ahthKey:['merchant','employee'],},
                    { code:'f-2-4' , name:'已到账',ahthKey:['employee'] },
                    { code:'f-2-5' , name:'未到账',ahthKey:['employee']  },
                    { code:'f-2-6' , name:'转账登记',ahthKey:['merchant']  },
                ]
            },
            {
                // code:'i1' ,
                name:'收款报表' ,ahthKey:['merchant','employee'],children:[
                    { code:'i-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'i-1-1' , name:'导出',ahthKey:['merchant','employee'] },
                    // { code:'i-1-2' , name:'账单详情',ahthKey:['merchant','employee'] },
                     { code:'i-1-2' , name:'导出详情',ahthKey:['merchant','employee'] },
                     { code:'i-1-3' , name:'详情',ahthKey:['merchant','employee'] },
                ]
            },
            {
                // code:'a1' ,
                name:'收款提醒' ,ahthKey:['merchant','employee'],children:[
                    { code:'a-1' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'a-1-2' , name:'导出',ahthKey:['merchant','employee'] },
                    { code:'a-1-3' , name:'发送催收短信',ahthKey:['merchant','employee'] },
                ]
            },
            {
                // code:'a1' ,
                name:'收据打印' ,ahthKey:['merchant'],children:[
                    { code:'e-10' , name:'菜单',ahthKey:['merchant'] },
                    { code:'e-10-1' , name:'收款打印',ahthKey:['merchant'] },
                ]
            },
            {
                name:'商家对账' ,ahthKey:['merchant', 'employee'],children:[
                    { code:'e-11' , name:'菜单',ahthKey:['merchant', 'employee'] },
                    { code:'e-11-1' , name:'编辑',ahthKey:['employee'] },
                    { code:'e-11-2' , name:'详情',ahthKey:['merchant', 'employee'] },
                    { code:'e-11-3' , name:'对账审批流程列表',ahthKey:[ 'employee'] },
                    { code:'e-11-4' , name:'清空汇集数据',ahthKey:[ 'employee'] },
                    { code:'e-11-5' , name:'初始化汇集数据',ahthKey:[ 'employee'] },
                    { code:'e-11-6' , name:'确认流程',ahthKey:['merchant'] },
                    { code:'e-11-7' , name:'发起流程',ahthKey:[ 'employee'] },
                    { code:'e-11-8' , name:'撤回流程',ahthKey:[ 'employee'] },
                    { code:'e-11-9' , name:'发起云贷划账申请',ahthKey:[ 'employee'] },
                    { code:'e-11-10' , name:'发起业主租金划账申请',ahthKey:[ 'employee'] },
                    { code:'e-11-11' , name:'发起平台运营费用划账申请',ahthKey:[ 'employee'] },
                ]
            },
            {
                name: '银联划账管理', ahthKey: ['employee'], children: [
                    {code: 'e-12', name: '菜单', ahthKey: ['employee']},
                    {code: 'e-12-1', name: '详情', ahthKey: ['employee']},
                    {code: 'e-12-5', name: '新增', ahthKey: ['employee']},
                    {code: 'e-12-6', name: '修改', ahthKey: ['employee']},
                    {code: 'e-12-7', name: '对账记录详情', ahthKey: ['employee']},
                    {code: 'e-12-8', name: '划账结算详情', ahthKey: ['employee']},
                    {code: 'e-12-2', name: '流程审批', ahthKey: ['employee']},
                    {code: 'e-12-3', name: '审批记录', ahthKey: ['employee']},
                    {code: 'e-12-4', name: '审批记录', ahthKey: ['employee']},
                ]
            },
            {
                name: '银联划账提醒', ahthKey: ['employee'], children: [
                    {code: 'e-15', name: '菜单', ahthKey: ['employee']},
                    {code: 'e-15-1', name: '详情', ahthKey: ['employee']},
                ]
            },
            {
                name: '对账报表', ahthKey: ['employee'], children: [
                    {code: 'e-13', name: '菜单', ahthKey: ['employee']},
                    {code: 'e-13-1', name: '导出', ahthKey: ['employee']},
                ]
            },
            {
                name: '平台对账', ahthKey: ['employee'], children: [
                    {code: 'e-14', name: '菜单', ahthKey: ['employee']},
                    {code: 'e-14-1', name: '详情', ahthKey: ['employee']},
                    {code: 'e-14-2', name: '人工对账', ahthKey: ['employee']},
                    {code: 'e-14-3', name: '系统对账', ahthKey: ['employee']},
                    {code: 'e-14-4', name: '批量人工对账', ahthKey: ['employee']},
                ]
            },
            {
                name: '惠市宝商户分账', ahthKey: ['employee'], children: [
                    {code: 'e-16', name: '菜单', ahthKey: ['employee']}
                ]
            },
            {
                name: '项目监控统计', ahthKey: ['employee'], children: [
                    {code: 'e-17', name: '菜单', ahthKey: ['employee']},
                    {code: 'e-17-1', name: '导出', ahthKey: ['employee']}
                ]
            }
        ]
    },
    // {
    //     name: '流水',
    //     // code: 'f',
    //     children:[
    //
    //     ]
    // },
    {
        name: '人员',
        // code: 'g',
        children:[
            {
                // code:'g1' ,
                name:'人员管理' ,ahthKey:['employee'],children:[
                    { code:'g-1' , name:'菜单' ,ahthKey:['employee']},
                    { code:'g-1-2' , name:'新增',ahthKey:['employee'] },
                    { code:'g-1-3' , name:'编辑',ahthKey:['employee'] },
                    { code:'g-1-4' , name:'删除',ahthKey:['employee'] },
                ]
            },
            {
                // code:'g2' ,
                name:'岗位管理' ,ahthKey:['employee'],children:[
                    { code:'g-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'g-2-2' , name:'新增',ahthKey:['employee'] },
                    { code:'g-2-3' , name:'编辑',ahthKey:['employee'] },
                    { code:'g-2-4' , name:'删除',ahthKey:['employee'] },
                ]
            },
            {
                // code:'g3' ,
                name:'部门管理' ,ahthKey:['employee'],children:[
                    { code:'g-3' , name:'菜单',ahthKey:['employee'] },
                    { code:'g-3-2' , name:'新增',ahthKey:['employee'] },
                    { code:'g-3-3' , name:'编辑',ahthKey:['employee'] },
                    { code:'g-3-4' , name:'删除',ahthKey:['employee'] },
                ]
            },
        ]
    },
    {
        name: '商户管理',
        // code: 'h',
        children:[
            {
                // code:'h1' ,
                name:'商户管理' ,ahthKey:['employee'],children:[
                    { code:'h-1' , name:'菜单',ahthKey:['employee'] },
                    { code:'h-1-2' , name:'新增',ahthKey:['employee'] },
                    { code:'h-1-3' , name:'编辑',ahthKey:['employee'] },
                    { code:'h-1-4' , name:'删除',ahthKey:['employee'] },
                    { code:'h-1-5' , name:'分账配置',ahthKey:['employee'] },
                   /* { code:'h-1-6' , name:'惠市宝渠道配置',ahthKey:['employee'] },*/
                    { code:'h-1-7' , name:'创建租金汇集计划',ahthKey:['employee'] },
                    { code:'h-1-8' , name:'租金汇集计划详情',ahthKey:['employee'] },
                    { code:'h-1-9' , name:'重置租金汇集计划',ahthKey:['employee'] },
                    { code:'h-1-10' , name:'设备管理',ahthKey:['employee'] },
                ]
            },
            {
                // code:'h2' ,
                name:'部门管理' ,ahthKey:['merchant'],children:[
                    { code:'h-2' , name:'菜单',ahthKey:['merchant'] },
                    { code:'h-2-2' , name:'新增',ahthKey:['merchant'] },
                    { code:'h-2-3' , name:'编辑',ahthKey:['merchant'] },
                    { code:'h-2-4' , name:'删除',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'h3' ,
                name:'人员管理' ,ahthKey:['merchant'],children:[
                    { code:'h-3' , name:'菜单',ahthKey:['merchant'] },
                    { code:'h-3-2' , name:'新增',ahthKey:['merchant'] },
                    { code:'h-3-3' , name:'编辑',ahthKey:['merchant'] },
                    { code:'h-3-4' , name:'删除',ahthKey:['merchant'] },
                    { code:'h-3-5' , name:'发送签约短信' ,ahthKey:['merchant']},
                    { code:'h-3-6' , name:'状态变更' ,ahthKey:['merchant']},
                ]
            },
            {
                // code:'h4' ,
                name:'岗位管理' ,ahthKey:['merchant'],children:[
                    { code:'h-4' , name:'菜单',ahthKey:['merchant'] },
                    { code:'h-4-2' , name:'新增' ,ahthKey:['merchant']},
                    { code:'h-4-3' , name:'编辑',ahthKey:['merchant'] },
                    { code:'h-4-4' , name:'删除',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'h4' ,
                name:'惠市宝市场同步信息' ,ahthKey:['employee'],children:[
                    { code:'h-7' , name:'菜单',ahthKey:['employee'] },
                    { code:'h-7-2' , name:'商户信息详情' ,ahthKey:['employee']},
                    { code:'h-7-3' , name:'商户信息同步数据',ahthKey:['employee'] },
                    { code:'h-7-4' , name:'分账规则详情' ,ahthKey:['employee']},
                    { code:'h-7-5' , name:'分账规则同步数据',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'项目管理' ,ahthKey:['employee'],children:[
                    { code:'d-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'d-2-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'d-2-3' , name:'新增项目',ahthKey:['employee'] },
                    { code:'d-2-4' , name:'删除',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'收房合同管理' ,ahthKey:['employee'],children:[
                    { code:'z-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'z-2-1' , name:'编辑',ahthKey:['employee'] },
                    { code:'z-2-2' , name:'房租周期',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'威富通支付渠道管理' ,ahthKey:['employee'],children:[
                    { code:'j-8' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-8-1' , name:'新增',ahthKey:['employee'] },
                    { code:'j-8-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'j-8-3' , name:'状态变更',ahthKey:['employee'] },
                    { code:'j-8-4' , name:'操作日志',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'威富通分账配置管理' ,ahthKey:['employee'],children:[
                    { code:'j-9' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-9-1' , name:'新增',ahthKey:['employee'] },
                    { code:'j-9-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'j-9-3' , name:'删除',ahthKey:['employee'] },
                    { code:'j-9-4' , name:'状态变更',ahthKey:['employee'] },
                    { code:'j-9-5' , name:'操作日志',ahthKey:['employee'] },
                    { code:'j-9-6' , name:'复制',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'惠市宝支付渠道管理' ,ahthKey:['employee'],children:[
                    { code:'j-5' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-5-1' , name:'新增',ahthKey:['employee'] },
                    { code:'j-5-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'j-5-3' , name:'状态变更',ahthKey:['employee'] },
                    { code:'j-5-4' , name:'操作日志',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'惠市宝分账规则管理' ,ahthKey:['employee'],children:[
                    { code:'j-6' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-6-1' , name:'新增',ahthKey:['employee'] },
                    { code:'j-6-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'j-6-3' , name:'删除',ahthKey:['employee'] },
                    { code:'j-6-4' , name:'状态变更',ahthKey:['employee'] },
                    { code:'j-6-5' , name:'操作日志',ahthKey:['employee'] },
                    { code:'j-6-6' , name:'复制',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'优惠券管理' ,ahthKey:['employee'],children:[
                    { code:'j-3' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-3-1' , name:'新增',ahthKey:['employee'] },
                    { code:'j-3-2' , name:'编辑',ahthKey:['employee'] },
                    { code:'j-3-3' , name:'状态变更',ahthKey:['employee'] },
                ]
            },
            {
                // code:'d2' ,
                name:'优惠券领取记录管理' ,ahthKey:['employee'],children:[
                    { code:'j-4' , name:'菜单',ahthKey:['employee'] },
                ]
            }
        ]
    },
    // {
    //     name: '报表',
    //     // code: 'i',
    //     children:[
    //         {
    //             // code:'i1' ,
    //             name:'收款报表' ,ahthKey:['merchant','employee'],children:[
    //                 { code:'i-1' , name:'菜单',ahthKey:['merchant','employee'] },
    //                 { code:'i-1-1' , name:'导出',ahthKey:['merchant','employee'] },
    //                 { code:'i-1-2' , name:'导出详情',ahthKey:['merchant','employee'] },
    //                 { code:'i-1-3' , name:'详情',ahthKey:['merchant','employee'] },
    //             ]
    //         }
    //     ]
    // },
    {
        name: '渠道管理',
        children: [
            {
                name: '渠道', ahthKey: ['employee'], children: [
                    { code:'k-1' , name:'菜单',ahthKey:['employee'] },
                    { code:'k-1-1', name:'新增' ,ahthKey:['employee'] },
                    { code:'k-1-2', name:'编辑' ,ahthKey:['employee'] },
                    { code:'k-1-3', name:'修改状态' ,ahthKey:['employee'] },
                    { code:'k-1-4', name:'复制地址' ,ahthKey:['employee'] },
                ]
            },
            {
                name: '客户', ahthKey: ['employee'], children: [
                  { code: 'm-1', name: '菜单', ahthKey: ['employee'] }
                ]
            },
        ]
    },
    {
        name: '其他',
        // code: 'j',
        children:[
            {
                // code:'j1' ,
                name:'短信发送明细' ,ahthKey:['employee'],children:[
                    { code:'j-1' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-1-2' , name:'导出',ahthKey:['employee'] },
                ]
            },
            {
                // code:'j2' ,
                name:'建融异常数据' ,ahthKey:['employee'],children:[
                    { code:'j-2' , name:'菜单',ahthKey:['employee'] },
                    { code:'j-2-2' , name:'标记处理',ahthKey:['employee'] },
                    { code:'j-2-3' , name:'标记处理所有',ahthKey:['employee'] },
                ]
            },
            {
                // code:'j1' ,
                name:'租金宝同步数据报表' ,ahthKey:['employee'],children:[
                    { code:'j-3' , name:'菜单',ahthKey:['employee'] }
                ]
            },
        ]
    },
    {
        name: '运营管理',
        // code: 'z',
        children:[
            {
                // code:'j1' ,
                name:'房源列表' ,ahthKey:['merchant'],children:[
                    { code:'z-1' , name:'菜单',ahthKey:['merchant'] },
                    { code:'z-1-2' , name:'一键核对',ahthKey:['merchant'] },
                    { code:'z-1-3' , name:'生成账单模板',ahthKey:['merchant'] },
                    { code:'z-1-4' , name:'设备清单',ahthKey:['merchant','employee'] },
                    { code:'z-1-5' , name:'核对清单',ahthKey:['merchant'] },
                    { code:'z-1-6' , name:'添加设备备注',ahthKey:['merchant'] },
                    { code:'z-1-7' , name:'报修记录',ahthKey:['merchant','employee'] },
                    { code:'z-1-8' , name:'导入验收日期',ahthKey:['merchant'] },
                    { code:'z-1-9' , name:'生成验收日期模板',ahthKey:['merchant'] }
                ]
            },
            {
                // code:'j1' ,
                name:'设备二维码' ,ahthKey:['merchant'],children:[
                    { code:'z-6' , name:'菜单',ahthKey:['merchant'] },
                    { code:'z-6-2' , name:'一键生成二维码',ahthKey:['merchant'] },
                    { code:'z-6-3' , name:'导出二维码压缩包',ahthKey:['merchant'] },
                    { code:'z-6-4' , name:'导出Excel',ahthKey:['merchant'] },
                    { code:'z-6-5' , name:'下载二维码',ahthKey:['merchant'] },
                    { code:'z-6-6' , name:'报修记录',ahthKey:['merchant','employee'] },
                ]
            },
            {
                // code:'j1' ,
                name:'报修管理' ,ahthKey:['merchant'],children:[
                    { code:'z-3' , name:'菜单',ahthKey:['merchant'] },
                    { code:'z-3-2' , name:'导出报修记录',ahthKey:['merchant','employee'] },
                    { code:'z-3-3' , name:'报修详情',ahthKey:['merchant','employee'] },
                    { code:'z-3-4' , name:'添加维修记录',ahthKey:['merchant'] },
                    { code:'z-3-5' , name:'状态变更',ahthKey:['merchant'] },
                ]
            },
            {
                // code:'j1' ,
                name:'设备账单' ,ahthKey:['merchant'],children:[
                    { code:'z-4' , name:'菜单',ahthKey:['merchant'] },
                    { code:'z-4-2' , name:'账单模板下载',ahthKey:['merchant'] },
                    { code:'z-4-3' , name:'导入设备账单',ahthKey:['merchant'] },
                    { code:'z-4-4' , name:'账单详情',ahthKey:['merchant','employee'] },
                    { code:'z-4-5' , name:'导出设备账单',ahthKey:['merchant','employee'] },
                ]
            },
            {
                // code:'j1' ,
                name:'账单核销' ,ahthKey:['merchant'],children:[
                    { code:'z-5' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'z-5-2' , name:'核销登记',ahthKey:['merchant'] },
                    { code:'z-5-3' , name:'账单详情',ahthKey:['merchant'] },
                ]
            },
            {
                name:'设备收款报表' ,ahthKey:['merchant'],children:[
                    { code:'z-7' , name:'菜单',ahthKey:['merchant','employee'] },
                    { code:'z-7-1' , name:'导出',ahthKey:['merchant','employee']  },
                ]
            }
        ]
    }

  /*  {  name: '户型管理', code: 'm', ahthKey: ['merchant'], children: [] },*/
]

/**
 *
 * @param {'merchant' | 'employee'} Auth 身份
 * @returns
 */
export const authKeyFn = (Auth)=>{
    let arr = JSON.parse(JSON.stringify(authKey))

    //获取登录信息中的建融家园标识  1=是 2=否
    let isJr = handleExportParams().isJr;

    //设置默认值未建融家园用户
    let isNotJr=2;

    return arr.filter(e=> {
        if (handleExportParams().merchantId > 0) {
            if (isJr === isNotJr && e.isJr) {
                return false;
            }
        }
        e.children = e.children.filter(ele=>{
            if (handleExportParams().merchantId > 0) {
                if (isJr === isNotJr && ele.isJr) {
                    return false;
                }
            }
            ele.children = ele.children.filter(element=> element.ahthKey.indexOf(Auth) >-1)
            return ele.children.length>0
        })
        return e.children.length>0
    })
}
/*Auth : 身份*/
export const adminAuthKey = (Auth)=>{
    let arr = authKeyFn(Auth),
        keyArr = [];
    arr.forEach(e=>{
        e.children.forEach(ele=> {
            ele.children.forEach(element=>{
                keyArr.push(element.code)
            })
            keyArr.push(ele.code)
        })
    })
    return keyArr
}



/**
 * 用于处理 table 中 action的按钮都没权限时还在占位的问题
 *
 * @param {*} columns table需要处理的column
 * @param {*} actionKeyList 需要检查的操作按钮的key的集合
 * @param {*} configAuth 已经拥有的权限数据
 * @param {string} [actionColumnKey='action'] 当前column中 操作栏的key值
 */
export const filterColumnAction = (columns, actionKeyList=[], configAuth,  actionColumnKey='action') => {
    const actionColumnIndex = columns.findIndex(e => e.dataIndex === actionColumnKey)

    const checkAuth = (key) =>{
        let {authKeyList,isAdmin,menusAuth } = configAuth
        let adminAuth = adminAuthKey(menusAuth)
        if(!key) return false
        if(!authKeyList) return false
        if(isAdmin) {
            if( adminAuth.indexOf(key) > -1 ) return true
            if(Array.isArray(key)) return key.some(e=>adminAuth.indexOf(e) > -1)
        }

        if(!isAdmin && Array.isArray(key)) return key.some(e=> authKeyList.indexOf(e) > -1 )

        return authKeyList.indexOf(key) > -1
    }
    const isShowAction = actionKeyList.filter(e => checkAuth(e)).length > 0

    if(isShowAction) {
        return columns
    }
    columns.splice(actionColumnIndex,1)
    return columns
}


// WEBPACK FOOTER //
// ./src/axios/authKey.js